export const config = {
  eventGroup: 'jxsj_xfyy_mo_20260924',
  identify: 'jxsj2',
  eventTags: ['jxsj', 'mo']
};

/**
 * 当不主动设置时采取默认上报
 */
// noinspection JSUnresolvedVariable
if (IS_MASTER_ENV && typeof DEPLOY_MASTER_HTTP_URL === 'string' && config.identify === 'other') {
  // noinspection JSUnresolvedVariable
  const url = DEPLOY_MASTER_HTTP_URL;
  const identify = url.split('.')[0];
  const validIdentifierList = [
    'jx3',
    'jx3yq',
    'daily',
    'js3',
    'js2',
    'zjjh',
    'jxsj2',
    'jx',
    'jx2',
    'zzq',
    'gcg2',
    'cpol',
    'jx3wbl',
    'xoyo',
    'sx',
    'projectcat',
    'jxgl',
    'ssg',
    'cityscape'
  ];
  config.identify = validIdentifierList.indexOf(identify) > -1 ? identify : 'xishanju_com';
  const matches = url.match(/\/(\w+)\//);
  config.eventTags = matches ? [matches[1]] : [];
  // noinspection SpellCheckingInspection
  config.eventGroup = url
    .replace('.xoyo.com', '')
    .replace(/\/$/, '')
    .replace(/[./-]/g, '_');
}

console.log('埋点上报参数: ' + JSON.stringify(config));

export default function createTracker(report, getDiffRouteTime) {
  return {
    loadPage: function() {
      report({
        eventName: 'load_page',
        eventDescription: '页面加载(默认上报，页面全部加载完才上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    pageLeave: function() {
      report({
        eventName: 'page_leave',
        eventDescription: '离开页面(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageStart: function() {
      report({
        eventName: 'load_page_start',
        eventDescription: '页面加载(默认上报，进入页面就上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    clickGoGuanwang: function() {
      report({
        eventName: 'click_go_guanwang',
        eventDescription: '进入官网'
      });
    },
    clickGoSpecial: function() {
      report({
        eventName: 'click_go_special',
        eventDescription: '资料片专题'
      });
    },
    clickSubscribe: function() {
      report({
        eventName: 'click_subscribe',
        eventDescription: '立即预约'
      });
    },
    clickIdentityValidate: function() {
      report({
        eventName: 'click_identity_validate',
        eventDescription: '身份验证'
      });
    },
    /**
     * @param {string} [title] - 上报不同的礼包
     */
    clickBuyGoods: function(title) {
      report({
        eventName: 'click_buy_goods',
        eventDescription: '我要购买',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    clickActivityHomepage: function() {
      report({
        eventName: 'click_activity_homepage',
        eventDescription: '活动首页'
      });
    },
    clickValuePack: function() {
      report({
        eventName: 'click_value_pack',
        eventDescription: '特惠礼包'
      });
    },
    clickMoreContent: function() {
      report({
        eventName: 'click_more_content',
        eventDescription: '更多内容'
      });
    },
    clickActivityRule: function() {
      report({
        eventName: 'click_activity_rule',
        eventDescription: '活动规则'
      });
    },
    /**
     * @param {string} [passport] - 通行证账号
     */
    clickLogout: function(passport) {
      report({
        eventName: 'click_logout',
        eventDescription: '退出',
        eventDataValue: {
          passport: passport
        },
        types: {
          passport: checkTypeHOF('string')
        }
      });
    },
    clickBindPhone: function() {
      report({
        eventName: 'click_bind_phone',
        eventDescription: '去绑定手机'
      });
    },
    clickHaveBindPhone: function() {
      report({
        eventName: 'click_have_bind_phone',
        eventDescription: '我已绑定手机'
      });
    },
    clickCreateTeam: function() {
      report({
        eventName: 'click_create_team',
        eventDescription: '创建购买队伍'
      });
    },
    clickUrlBuy: function() {
      report({
        eventName: 'click_url_buy',
        eventDescription: '复制专属链接'
      });
    },
    /**
     * @param {string} [nameId] - 邀请码
     */
    clickJoinTeam: function(nameId) {
      report({
        eventName: 'click_join_team',
        eventDescription: '加入购买队伍',
        eventDataValue: {
          name_id: nameId
        },
        types: {
          name_id: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [nameId] - 邀请码
     */
    clickCreateTeamLink: function(nameId) {
      report({
        eventName: 'click_create_team_link',
        eventDescription: '创建购买队伍',
        eventDataValue: {
          name_id: nameId
        },
        types: {
          name_id: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [nameId] - 邀请码
     */
    clickSubscribeLink: function(nameId) {
      report({
        eventName: 'click_subscribe_link',
        eventDescription: '立即预约',
        eventDataValue: {
          name_id: nameId
        },
        types: {
          name_id: checkTypeHOF('string')
        }
      });
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
